// config/api.js - API Configuration with environment variables
export const API_CONFIG = {
  // BASE_URL should be just the domain, no path
  BASE_URL: process.env.REACT_APP_API_URL || 'http://192.168.70.170:8000',
  ENDPOINTS: {
    // Changed from /ucsnose/api/ to /api/ since nginx handles the /ucsnose prefix
    BOXES: '/api/boxes',
    BOX_DETAIL: (boxId) => `/api/boxes/${boxId}`,
    BOX_MEASUREMENTS: (boxId) => `/api/boxes/${boxId}/measurements`,
    LATEST_MEASUREMENTS: (boxId) => `/api/measurements/${boxId}/latest`,
    SENSORS: (boxId) => `/api/boxes/${boxId}/sensors`,
    // New endpoint for individual sensor measurements with time range
    SENSOR_MEASUREMENTS: (boxId, sensorId) => `/api/measurements/${boxId}?sensor_id=${sensorId}`,
    EVALUATION_SETTINGS: (boxId) => `/api/evaluation_settings/${boxId}`,
    EVALUATION_RESULTS: (boxId) => `/api/evaluation_results/${boxId}`,

    // NEW: Anomaly detector endpoints
    ANOMALY_DETECTORS_LIST: (boxId) => `/api/anomaly_detectors/${boxId}`,
    ANOMALY_DETECTOR_METADATA: (boxId, version) => `/api/anomaly_detectors/${boxId}/${version}`,
    ANOMALY_DETECTOR_ARTIFACT: (boxId, version) => `/api/anomaly_detectors/${boxId}/${version}/artifact`,
    ANOMALY_DETECTOR_UPLOAD: (boxId, version) => `/api/anomaly_detectors/${boxId}/${version}`,
  },
  DEFAULT_HEADERS: {
    'accept': 'application/json',
    'Content-Type': 'application/json',
  },
  TIMEOUT: parseInt(process.env.REACT_APP_API_TIMEOUT) || 10000, // 10 seconds default
};